export default __webpack_public_path__ + "static/media/img_complete_flexibility.08c88328.png";